import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://hzaregpcpuisrtvicdkh.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imh6YXJlZ3BjcHVpc3J0dmljZGtoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzQ3MTUzMDMsImV4cCI6MjA5MDI5MTMwM30.7BiitV7A98SU87KgJIOpP0PutfI4zBGXO6jaudrH-K0'

export const supabase = createClient(supabaseUrl, supabaseKey)
